module.exports = __webpack_public_path__ + "static/media/dongyanshan4.c72a4ace.webp";